import { FieldTypes } from '../../constants/FieldTypes'
import { addCondition } from '../../fields/utils'
import {
  CheckboxField,
  DropdownField,
  FieldMap,
  TextAreaField,
  TextField,
  TimeField,
} from '../../types/forms/fields'

const bankingDecisionField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Banking Decision',
  inputType: 'radio',
  options: [
    { id: 'yes', text: 'Yes — banking elected' },
    { id: 'no', text: 'No' },
    { id: 'declined', text: 'Declined to decide' },
  ],
}

const collectionKitPresentField: CheckboxField = addCondition(
  {
    type: FieldTypes.CHECKBOX,
    placeholder: 'Collection kit confirmed present at delivery',
    optional: true,
  },
  v => v?.bankingDecision === 'yes',
)

const collectionPerformedField: DropdownField = addCondition(
  {
    type: FieldTypes.DROPDOWN,
    placeholder: 'Collection Performed',
    inputType: 'radio',
    options: [
      { id: 'yes', text: 'Yes' },
      { id: 'no', text: 'No' },
    ],
    optional: true,
  },
  v => v?.bankingDecision === 'yes',
)

const collectionNotPerformedReasonField: TextAreaField = addCondition(
  {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Reason collection not performed',
    optional: true,
  },
  v => v?.bankingDecision === 'yes' && v?.collectionPerformed === 'no',
)

const bankingCompanyNameField: TextField = addCondition(
  {
    type: FieldTypes.TEXT,
    placeholder: 'Banking company name',
    optional: true,
  },
  v => v?.bankingDecision === 'yes',
)

const collectionTimeField: TimeField = {
  type: FieldTypes.TIME,
  placeholder: 'Collection time',
  optional: true,
}

const chainOfCustodyConfirmationField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Collection kit labeled, sealed, and handed to courier / courier contacted',
  optional: true,
}

export const cordBloodBankingField: FieldMap = {
  name: 'Cord Blood Banking',
  children: {
    bankingDecision: bankingDecisionField,
    collectionKitPresent: collectionKitPresentField,
    collectionPerformed: collectionPerformedField,
    collectionNotPerformedReason: collectionNotPerformedReasonField,
    bankingCompanyName: bankingCompanyNameField,
    collectionTime: collectionTimeField,
    chainOfCustodyConfirmation: chainOfCustodyConfirmationField,
  },
}
